import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { RcsApi } from 'entities/Rcs'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'
import { SenderDetailsStore } from 'pages/settings/pages/rcsV2/pages/SenderDetails/store/senderDetailsStore'
import { CountriesStore } from 'pages/settings/pages/rcsV2/pages/Countries/store/countriesStore'
import { ContactInfoStore } from 'pages/settings/pages/rcsV2/pages/ContactInfo/store/contactInfoStore'
import { UseCaseStore } from 'pages/settings/pages/rcsV2/pages/UseCase/store/useCaseStore'
import { OptInMessageInfoStore } from 'pages/settings/pages/rcsV2/pages/OptInMessageInfo/store/optInMessageInfoStore'
import { ReviewStore } from 'pages/settings/pages/rcsV2/pages/Review/store/reviewStore'
import { RcsWizardNavigationStore } from './rcsWizardNavigationStore'

export class RcsWizardStore {
  private _loading = true
  readonly navigationStore: RcsWizardNavigationStore
  readonly senderStore: SenderDetailsStore
  readonly countriesStore: CountriesStore
  readonly contactInfoStore: ContactInfoStore
  readonly useCaseStore: UseCaseStore
  readonly optInMessageInfoStore: OptInMessageInfoStore
  readonly reviewStore: ReviewStore

  constructor() {
    this.navigationStore = new RcsWizardNavigationStore(this)
    this.senderStore = new SenderDetailsStore()
    this.countriesStore = new CountriesStore()
    this.contactInfoStore = new ContactInfoStore()
    this.useCaseStore = new UseCaseStore()
    this.optInMessageInfoStore = new OptInMessageInfoStore()
    this.reviewStore = new ReviewStore()

    makeAutoObservable(this)
    this.init()
  }

  get loading() {
    return this._loading
  }

  init = async () => {
    try {
      const { data } = await RcsApi.getRcs()

      if (data?.length) {
        uiStore.changeRoute({ path: RcsPath.root })
        return
      }
    } catch (error) {
      logger.error(error)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  closeWizard = () => {
    uiStore.changeRoute({ path: RcsPath.root })
  }

  dispose = () => {
    this.senderStore.dispose()
  }
}
